import "./App.css";
import Home from "./pages/home";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import GMLL from "./pages/gmll";
import Fundacion from "./pages/fundacion";
import TalleresPeriodismo from "./pages/talleresPeriodismo";
import Oum from "./pages/oum";
import CulturaDigital from "./pages/culturaDigital";
import ProyectoDemocracia from "./pages/proyectoDemocracia";
import DebateEducacion from "./pages/debateEducacion";
import TribunalConstitucional from "./pages/tribunalConstitucional";
import Trayectoria from "./pages/trayectoria";
import Sidebar from "./components/Sidebar";
import ScrollToTop from "./components/ScrollToTop";
import { useEffect } from "react";

function App() {
  useEffect(() => {
    if(window.location.hash) {
      window.scrollTo(0,findPosition(document.getElementById(window.location.hash.substring(1,100) ))); 
    }
  }, [])
  const findPosition = (obj) => {
    let currenttop = 0; 
    if (obj.offsetParent) { 
       do { 
           currenttop += obj.offsetTop;
        } while ((obj = obj.offsetParent)); 
       return [currenttop]; 
      } 
   } 
  return (
    <BrowserRouter basename="/especiales/memoria-2024">
      <Sidebar />
      <div className="content-memoria">
        <ScrollToTop>
          <Routes >
            <Route path="/" element={<Home />}></Route>
            <Route path="/gustavo-mohme-llona" element={<GMLL />}></Route>
            <Route path="/fundacion" element={<Fundacion />}></Route>
            <Route
              path="/talleres-periodismo"
              element={<TalleresPeriodismo />}
            ></Route>
            <Route
              path="/observatorio-universitario-medios"
              element={<Oum />}
            ></Route>
            <Route path="/cultura-digital" element={<CulturaDigital />}></Route>
            <Route
              path="/proyecto-democracia"
              element={<ProyectoDemocracia />}
            ></Route>
            <Route
              path="/debate-educacion"
              element={<DebateEducacion />}
            ></Route>
            <Route
              path="/participacion-ciudadana-tribunal-constitucional"
              element={<TribunalConstitucional />}
            ></Route>
            <Route
              path="/premios-trayectoria"
              element={<Trayectoria />}
            ></Route>
          </Routes>
        </ScrollToTop>
      </div>
    </BrowserRouter>
  );
}

export default App;
